import { render, staticRenderFns } from "./SurveyMain.vue?vue&type=template&id=08199242&scoped=true"
import script from "./SurveyMain.vue?vue&type=script&lang=js"
export * from "./SurveyMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08199242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08199242')) {
      api.createRecord('08199242', component.options)
    } else {
      api.reload('08199242', component.options)
    }
    module.hot.accept("./SurveyMain.vue?vue&type=template&id=08199242&scoped=true", function () {
      api.rerender('08199242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey-builder/components/SurveyMain.vue"
export default component.exports